// extracted by mini-css-extract-plugin
export var copyableField = "_oq-4";
export var customerBadge = "_oq-0";
export var customerInfoTitle = "_oq-2";
export var details = "_oq-1";
export var dropdownContainer = "_oq-5";
export var dropdownImage = "_oq-6";
export var editAssigneeForm = "_oq-a";
export var editButton = "_oq-3";
export var email = "_oq-7";
export var hidden = "_oq-d";
export var input = "_oq-8";
export var saveButton = "_oq-b";
export var shopifyIcon = "_oq-c";
export var suggestionBadge = "_oq-e";
export var suggestionText = "_oq-f";
export var username = "_oq-9";